"use client";
import React, { useEffect, useRef, useState } from "react";
import { usePathname } from "next/navigation";
import "./Header.css";
import "../../app/einbuergerungstest/mocktest/result/TestResult.css"
import Logo from "./Logo/Logo";
import strings from "../../config/App.json";
import { LuMenu } from "react-icons/lu";
import Image from "next/image";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navRef = useRef(null);
  const pathname = usePathname();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (isMenuOpen && navRef.current && !navRef.current.contains(e.target)) {
        setIsMenuOpen(false);
      }
    };

    const handleEscape = (e) => {
      if (e.key === "Escape" && isMenuOpen) {
        setIsMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    document.addEventListener("keydown", handleEscape);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
      document.removeEventListener("keydown", handleEscape);
    };
  }, [isMenuOpen]);

  return (
    <header className="header">
      <div className="header-container">
        <Logo />
        <button
          className="menu-icon"
          onClick={toggleMenu}
          aria-label="Toggle navigation menu"
          aria-expanded={isMenuOpen}
        >
          <LuMenu />
        </button>

        <nav className={`nav m-menu ${isMenuOpen ? "open" : ""}`} ref={navRef}>
          <ul className="nav-list mb-0">
            {pathname !== strings.HomePage && (
              <li>
                <a
                  href={strings.HomePage}
                  className="nav-links"
                >
                  Blogs
                </a>
              </li>
            )}
            <li>
              <a
                href={strings.ToolDetailsPage}
                className="nav-links"
              >
                Einbürgerungs Test
              </a>
            </li>
            <li>
              <a
                href={strings.JobBoardPage}
                className="nav-links"
              >
                Job Board
              </a>
            </li>
            <li>
              <a
                href={strings.BusinessListingPage}
                className="nav-links"
              >
                Business Listings
              </a>
            </li>
            <li>
              <a
                href={strings.ExclusivePartnersPage}
                className="nav-links"
              >
                Exclusive Partners
              </a>
            </li>
          </ul>

          <div className="nav-footer">
            <br />
            <div className="summary-divider"></div>
            <br />
            <div className="social-icons" id="nav-social-icons">
              <a
                href="https://www.instagram.com/munich.indians"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Image
                  src="/images/Footer/instagram.png"
                  alt="Instagram"
                  width={24}
                  height={24}
                />
              </a>
              <a
                href="https://www.youtube.com/@munich.indians"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Image
                  src="/images/Footer/youtube.png"
                  alt="YouTube"
                  width={24}
                  height={24}
                />
              </a>
              <a
                href="https://www.linkedin.com/company/munichindians"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Image
                  src="/images/Footer/linkedIn.png"
                  alt="LinkedIn"
                  width={24}
                  height={24}
                />
              </a>
            </div>
            <p className="copyright">
              © munichindians {new Date().getFullYear()}. All Rights Reserved.
            </p>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;
